<template>
  <div class="container">
    <div class="linner"></div>
    <div class="comment-list">
      <list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="cl-item" v-for="(item, index) in arlist" :key="index">
          <div class="user-img">
            <van-image
              round
              fit="cover"
              width="100%"
              height="100%"
              :src="item.thumb"
              alt=""
            />
          </div>
          <div class="cl-content">
            <div class="flex_b">
              <div class="user-box">
                <div class="name">{{ item.user }}</div>
                <div class="timer">{{ item.time }}</div>
              </div>
              <div
                @click="fabulous(item)"
                class="flex_c c-num"
                :class="item.isFabulous == 1 ? 'red' : ''"
              >
                <i class="iconfont icon-zan"></i>{{ item.fabulousNum }}
              </div>
            </div>
            <div class="c-c">
              {{ item.content }}
            </div>
          </div>
        </div>
      </list>
    </div>

    <!-- 评论 -->
    <div class="send-input">
      <div>
        <div class="text-box">
          <input
            ref="inp"
            type="text"
            v-model="sendText"
            placeholder="我也来说两句~"
          />
        </div>
        <div
          class="send"
          v-show="sendText"
          @mousedown.prevent
          @click.stop="communityComment"
        >
          发送
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { List } from "vant";
export default {
  components: { List },
  data() {
    return {
      id: "",
      arlist: [],
      loading: false,
      finished:false,
      page: 1,
      sendText:'',
      cflag:true
    };
  },
  methods: {
    onLoad() {
      this.articleCommentList();
      this.page++;
    },
    articleCommentList() {
      this.api.articleCommentList({ id: this.id,page:this.page }).then((res) => {
        this.arlist = [...this.arlist, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    fabulous(item) {
      this.api.articleCommentFabulous({ id: item.id }).then((res) => {
        if (item.isFabulous == 0) {
          item.isFabulous = 1;
          item.fabulousNum = Number(item.fabulousNum) + 1;
        } else {
          item.isFabulous = 0;
          item.fabulousNum = Number(item.fabulousNum) - 1;
        }
      });
    },
    //评论
    communityComment() {
      if (!this.cflag) return;

      this.cflag = false;
      this.api
        .articleComment({
          id: this.id,
          text: this.sendText,
        })
        .then(() => {
          this.articleCommentList();
          // const tz = this.list.find((o) => o.id == this.postsID);
          // const newobj = {
          //   title: this.sendText,
          //   name: JSON.parse(localStorage.getItem("user")).name,
          //   cid: this.postsID,
          //   pid: this.pid,
          //   pName: this.pName,
          //   uid: JSON.parse(localStorage.getItem("user")).id,
          // };
          // tz.commentList.push(newobj);
          this.showInput = false;
          this.sendText = "";
          this.cflag = true;
        });
    },
  },
  created() {
    this.cflag = true;
    this.id = this.$route.query.id;
    // this.articleCommentList();
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f1f1f1;
  height: 100vh;
  
  .linner {
    height: 0.16rem;
    width: 100%;
    background: #f1f1f1;
  }
}
.comment-list {
  padding: 0 0.24rem;
  padding-bottom: 50px;
  padding-top: 0.4rem;
  background: #fff;
  
  .c-more {
    margin-top: 0.4rem;
    font-size: 0.3rem;
    color: #72e0dd;
    text-align: center;
    padding-bottom: 0.3rem;
  }
  .cl-item {
    padding-bottom: 0.32rem;
    display: flex;
    // margin-bottom: 0.32rem;
    &:last-child {
      .cl-content {
        border: 0;
      }
    }
    .user-img {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 0.3rem;
    }
    .cl-content {
      flex: 1;
      border-bottom: 1px solid #e3e3e3;
      .user-box{
        height: 0.7rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .name {
        font-size: 0.28rem;
        color: #333;
        font-weight: bold;
        line-height: 1;
        // margin-bottom: 0.18rem;
      }
      .timer {
        font-size: 0.24rem;
        color: #999;
        line-height: 1;
      }
      .c-num {
        font-size: 0.26rem;
        color: #999;
        &.red {
          i {
            color: #f9647d;
          }
        }
        line-height: 1;
        align-items: flex-end;
        i {
          color: #999;
          margin-right: 0.16rem;
        }
      }
      .c-c {
        color: #333;
        font-size: 0.28rem;
        margin-top: 0.28rem;
        padding-bottom: 0.28rem;
      }
    }
  }
}
.flex_b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.send-input {
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 95%;
    height: 35px;

    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .text-box {
    padding: 0 10px;
    flex: 1;
    height: 100%;
    border-radius: 20px;
    background: #f2f2f2;
    overflow: hidden;
    input {
      border: none;
      outline: none;
      width: 100%;
      height: 100%;
      background: #f2f2f2;
      &::placeholder{
        color: #ccc;
      }
    }
  }
  .send {
    margin-left: 10px;
    background: #4fd9d5;
    font-size: 16px;
    height: 30px;
    color: #ffffff;
    border-radius: 5px;
    line-height: 30px;
    padding: 0 10px;
  }
}
</style>
